import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setGetReplenishmentReport } from '../../store/thunk/setGetReplenishmentReport';
import TemplatePage from '../../../components/templatePage';
import { setLoadingAction } from '../../../components/templatePage/store/action';
import ReplenishmentItem from '../../components/replenishmentItem';
import { setGetReplenishmentReportAction } from '../../store/action';
import moment from 'moment'
const handleLoadPagination = ({page, setPage, countPage}) => {
    if (page <= countPage) {
        setPage(page + 1);
    }
}

const handleLoading = (dispatch) => {
    dispatch(setLoadingAction(true))
}


const Replenishment = () => {
    const utc = moment.utc().valueOf();
    const dispatch = useDispatch();
    const [current_date, setCurrentDate] = React.useState(utc)
    const [startDate, setStartDate] = React.useState(0);
    const [page, setPage] = React.useState(1)
    const [search, setSearch] = React.useState('');

    React.useEffect(() => {
        dispatch(setGetReplenishmentReport({
            page: 1,
            rowsPerPage: (page + 1) * 10,
            search,
            date_from: startDate,
            date_to: current_date
        }));
    }, [search, startDate, current_date, page]);

    const list = useSelector(state => state.replenishmentMobile.list);

    return (
        <TemplatePage
            title="Отчет по игрокам и платежным методам"
            pagination={page < list.countPage && list.data.length}
            handleLoadPagination={() => handleLoadPagination({
                page,
                setPage,
                countPage: list.countPage,
            })}
            handleLoading={() => handleLoading(dispatch)}
            datePicker
            changeDate={({date_from, date_to}) => {
                dispatch(setGetReplenishmentReportAction({
                    data: [],
                    countPage: 1
                }));
                setCurrentDate(date_to);
                setStartDate(date_from);
                setPage(0)
            }}
            search={true}
            searchValue={search}
            onChangeSearch={(v) => {
                dispatch(setGetReplenishmentReportAction({
                    data: [],
                    countPage: 1
                })); 
                setSearch(v)
                setPage(0)
            }}
        >
            {
                list.data.map((item) => <ReplenishmentItem item={item}/>)
            }
            {
                !list.data.length && <span style={{width: '100%', color: '#fff', display: 'flex', justifyContent: 'center', padding: 20}}>Информация отсутствует</span>
            }
        </TemplatePage>
               

    )
}

export default Replenishment;